class LoginImpersonate {
  constructor() {
    const form = document.getElementById('login-impersonate-form');
    if (!form) return;

    const config = document.getElementById('login-impersonate-config');
    this.apiUrl = config?.dataset.apiUrl || 'https://frontend-api.kencko.com/api/v1/auth/admin/login';
    this.mockedCustomerHost = config?.dataset.mockedCustomerHost || 'www.kencko.com';

    form.addEventListener('submit', (e) => this.handleSubmit(e));

    form.querySelectorAll('.password-toggle-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const wrapper = btn.closest('.password-field-wrapper');
        const input = wrapper.querySelector('input');
        const isPassword = input.type === 'password';
        input.type = isPassword ? 'text' : 'password';
        wrapper.querySelector('.icon-eye-open').style.display = isPassword ? 'none' : '';
        wrapper.querySelector('.icon-eye-close').style.display = isPassword ? '' : 'none';
      });
    });
  }

  async handleSubmit(e) {
    e.preventDefault();

    const form = e.currentTarget;
    const email = form.querySelector('#ImpersonateEmail')?.value?.trim();
    const password = form.querySelector('#ImpersonatePassword')?.value;
    const mockedCustomerEmail = form.querySelector('#ImpersonateMockedEmail')?.value?.trim();

    const errorBox = document.getElementById('impersonate-error');
    const submitBtn = form.querySelector('[data-submit-btn]');

    errorBox.style.display = 'none';

    if (!email || !password || !mockedCustomerEmail) return;

    if (submitBtn) submitBtn.disabled = true;

    try {
      const response = await fetch(this.apiUrl, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          password,
          mockedCustomerEmail,
          mockedCustomerHost: this.mockedCustomerHost,
        }),
      });

      if (response.ok) {
        const text = await response.text().catch(() => '');
        let data = {};
        try { data = JSON.parse(text); } catch (_) {}
        const token = data?.token || data?.access_token || data?.data?.token;
        if (token) localStorage.setItem('kencko-access-token', token);
        localStorage.setItem('kencko-is-impersonate', 'true');
        this.shopifyLogin(email, password);
        return;
      }

      const text = await response.text().catch(() => '');
      let data = {};
      try { data = JSON.parse(text); } catch (_) {}
      const message = data?.message || data?.error || 'Login failed. Please check your credentials.';
      this.showError(errorBox, message);
    } catch (_) {
      this.showError(errorBox, 'Network error. Please try again.');
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  }

  shopifyLogin(email, password) {
    localStorage.setItem('kencko-bridge-done', 'true');

    const form = document.createElement('form');
    form.method = 'post';
    form.action = '/account/login';

    const fields = {
      'customer[email]': email,
      'customer[password]': password,
    };

    Object.entries(fields).forEach(([name, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  }

  showError(box, message) {
    box.querySelector('.impersonate-error-text').textContent = message;
    box.style.display = 'flex';
  }
}

document.addEventListener('DOMContentLoaded', () => new LoginImpersonate());
